import client from "../client"
import { parseValidationError } from '../responseHandlers';

export type TApiFolder = {
  id: number;
  parent_id: number;
  name: string;
  created: string;
  updated: string;
}

export type TApiFolderParams = {
  name: string;
}

const endpointPath = (id?: TApiFolder['id']) => {
  const path = id ?? '';

  return '/folder/' + path;
}

const list = (): Promise<Array<TApiFolder>> => client.get('/folder/').then(response => response.data);

const create = (params: TApiFolderParams): Promise<TApiFolder> =>
  client.post(endpointPath(), params).then(response => response.data).catch(parseValidationError);

const update = (id: TApiFolder['id'], params: TApiFolderParams): Promise<Array<TApiFolder>> =>
  client.put(endpointPath(id), params).then(response => response.data);

const remove = (id: TApiFolder['id']): Promise<Array<TApiFolder>> =>
  client.delete(endpointPath(id)).then(response => response.data);

export {
  create,
  list,
  update,
  remove
}
